import { c as _c } from "react/compiler-runtime";
import useModalStore from '@module/stores/useModalStore';
import { MyMenuFix, MyMenuFixOn } from '@module/svg/icons';
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import { useContext } from 'react';
import { AllMenuContainer } from './AllMenuContainer';
import MenuContext from './MenuContext';
import { menuSvg } from './menuSvg';
export function ChannelMenu() {
  const $ = _c(15);
  const {
    navigateHandler,
    selectList,
    addItemHandler,
    isAdult,
    initMyListHandler
  } = useContext(MenuContext);
  const {
    pushModal
  } = useModalStore();
  let t0;
  if ($[0] !== addItemHandler || $[1] !== initMyListHandler || $[2] !== isAdult || $[3] !== navigateHandler || $[4] !== pushModal || $[5] !== selectList) {
    let t1;
    if ($[7] !== addItemHandler || $[8] !== isAdult || $[9] !== navigateHandler || $[10] !== pushModal || $[11] !== selectList) {
      t1 = (el, i) => {
        const active = selectList.some(s => s.title === el.title);
        return <div className="item" key={i}><DropdownMenuItem className="text-box" onClick={() => {
            if (el.title === "\uD658\uC804") {
              if (!isAdult) {
                pushModal({
                  type: "IDENTITY_VERIFICATION_MODAL",
                  id: "ChannelMenu"
                });
                return;
              }
            }
            navigateHandler(el);
          }}><div className="w-5 ">{menuSvg[el.img]}</div><div>{el.title}</div></DropdownMenuItem>{isAdult && <div className="favorites-icon" onClick={e => addItemHandler(e, el)}>{active ? <MyMenuFixOn /> : <MyMenuFix />}</div>}</div>;
      };
      $[7] = addItemHandler;
      $[8] = isAdult;
      $[9] = navigateHandler;
      $[10] = pushModal;
      $[11] = selectList;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    t0 = initMyListHandler("chnnel").map(t1);
    $[0] = addItemHandler;
    $[1] = initMyListHandler;
    $[2] = isAdult;
    $[3] = navigateHandler;
    $[4] = pushModal;
    $[5] = selectList;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[13] !== t0) {
    t1 = <AllMenuContainer title={"\uCC44\uB110"} isbottom={true}><>{t0}</></AllMenuContainer>;
    $[13] = t0;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  return t1;
}